import { Routes } from '@angular/router';
import { authGuard, loginGuard } from '@nebula/shared-vault/data-access';
import { LayoutWrapperComponent } from '@nebula-vault/layout';
import { LOGIN_ROUTES } from '@nebula/vault/login';
import { VAULT_ROUTES } from '@nebula/vault';

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadChildren: () => Promise.resolve(LOGIN_ROUTES),
    canActivate: [loginGuard],
  },
  {
    path: 'layout',
    component: LayoutWrapperComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'vault/dashboard',
        pathMatch: 'full',
      },
      {
        path: 'vault',
        children: VAULT_ROUTES,
        data: {
          showSidebar: true,
          showHeader: true,
          showBreadcrumb: true,
        },
      },
      {
        path: 'company',
        loadChildren: () => import('@nebula/vault/company').then((m) => m.COMPANY_ROUTES),
        data: {
          showSidebar: false,
          showHeader: false,
          showBreadcrumb: false,
        },
      },
      {
        path: 'products',
        loadChildren: () => import('@nebula/vault/products').then((m) => m.PRODUCTS_ROUTES),
        data: {
          showSidebar: false,
          showHeader: false,
          showBreadcrumb: false,
        },
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];
